<template>

<div class="panel panel-clinic">

	<div class="panel-heading" href="#log_history" data-toggle="collapse">

		<div class="arrow-down"></div>

		<h2 class="panel-title">Historik</h2>

	</div>

	<div id="log_history" class="panel-collapse collapse">

		<div class="panel-body">

			<div class="list-group">

				<div class="list-group-item" v-for="entry in entries">
					<div class="row">
						<div class="col-md-10 col-xs-20" v-bind:class="{'deleted': entry.deleted_at != null}">
							{{ datetimeFormat(entry.created_at) }}<br />
							<span v-if="entry.admin">Admin: {{ entry.admin.name }}</span>
						</div>
						<div class="col-md-12 col-xs-30" v-bind:class="{'deleted': entry.deleted_at != null}">
							{{ entry.metaData.title }}
							<span v-if="entry.metaData.deviation_id != null">(manuell registrering)</span>
							<span v-if="entry.type == 'treatment' && entry.deleted_at != null">
							<br />Borttagen: {{ entry.deleted_at }}
							</span>
						</div>
						<div class="col-md-12 hidden-sm hidden-xs" v-bind:class="{'deleted': entry.deleted_at != null}">
							{{ entry.metaData.text }}
							<div v-if="entry.metaData.deviation_id != null">
								Orsak: {{ reasonNice(entry.metaData.deviation_reason) }} 
							</div>
						</div>
						<div class="col-md-10 hidden-sm hidden-xs">
						<textarea v-on:change="storeLog(entry)" placeholder="Anteckningar" class="form-control" style="background-color: #fffef3;" v-model="entry.metaData.free_text"></textarea>
						</div>
						<div class="col-md-5 col-xs-5"
							 v-if="entry.type == 'treatment' && entry.metaData.reported != true && entry.deleted_at == null"
							 v-on:click="removeTreatment(entry)">

							 	<a class="btn btn-info btn-sm pull-right">Ta bort klipp</a>
						</div>
					</div>
				</div>

			</div>

		</div>

	</div>

</div>

</template>

<script>

import momenter from '../../shared/mixins/momenter'

export default {

    mixins: [
        momenter
    ],

    props: {
	        url: {},
	        parameters: {}
	    },
	    data: function () {
        return {
            text: null,
            entries: []
        }
    },
	    created: function () {
	    	const self = this

	    	bus.$on('log-reload', function () {
	    		console.log('got log reload from bus')

	    		self.loadLog()
        })

        self.loadLog()
	    },
	    methods: {

	    	loadLog: function () {
	    		const self = this

	    		this.$http.post(self.url, self.parameters).then((response) => {
                self.entries = response.body
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},

	    	storeLog: function (entry) {
	    		const self = this

	    		console.log('store entry')
	    		console.log(entry)

	    		this.$http.post('/log/store', entry).then((response) => {
                console.log('got response')
                console.log(response.body)
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},

	    	removeTreatment: function (entry) {
            const self = this

	    		console.log('store entry')
	    		console.log(entry)

	    		this.$http.post('/log/removeTreatment', entry).then((response) => {
                console.log('got response')
                console.log(response.body)

                bus.$emit('notify', 'Behandlingen raderades.')
                bus.$emit('refresh-data')

                // self.loadLog();
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},
	    	reasonNice(reason)
	    	{
	    		if(reason == "no_show"){
	    			return "No show"
	    		}else if(reason == "late_cancelling"){
	    			return "Sen avbokning"
	    		}else if(reason == "no_app"){
	    			return "Kunden saknade appen"
	    		}else if(reason == "forgot"){
	    			return "Glömde ta klipp"
	    		}else if(reason == "tech_issue"){
	    			return "Tekniskt fel"
	    		}else if(reason == "other"){
	    			return "Övrigt"
	    		}
	    	}

	    }

}
</script>
